export default {
  type: 'timestamp',
  label: 'Tempo',
  shape: 'circle'
}